<template>
  <div class="access-layout">
    <enfold>
      <!-- AccessLayout -->
      <enfold-uc>
        <template slot="up">
          <div>
            <img class="icon" src="@/assets/images/public/public_return.png" @click="$router.go(-1)" alt />
            <img class="icon" src="@/assets/images/public/public_save.png" style="padding-top: 2px;"
              @click="setAuthorityByRoleId" alt />
          </div>
        </template>
        <template slot="center">
          <div v-loading="loading" style="height: 100%;">
            <div class="node-content-one" v-for="(oneItem, oneIndex) in authorityList" :key="oneIndex">
              <div v-if="oneItem.title !== '测试'">
                <el-checkbox :value="Boolean(isCheckedAll(oneItem))" :label="oneItem.title" border size="medium"
                  @change="handleCheckboxChange(oneItem)" :indeterminate="Boolean(isIndeterminate(oneItem))"
                  v-if="false"></el-checkbox>
                <div class="node-content-two">
                  <!-- 折叠面板 -->
                  <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item :title="twoItem.title" v-for="(twoItem, twoIndex) in oneItem.child"
                      :name="twoIndex" :key="twoIndex">
                      <template slot="title">
                        <el-checkbox @change.native.stop="handleCheckboxChange(twoItem)"
                          :value="Boolean(isCheckedAll(twoItem))" :label="twoItem.title"
                          :indeterminate="Boolean(isIndeterminate(twoItem))"></el-checkbox>
                      </template>
                      <div class="node-content-three">
                        <el-checkbox :value="Boolean(threeItem.checked)" :label="threeItem.title" size="small"
                          v-for="(threeItem, threeIndex) in twoItem.child" :key="threeIndex" border
                          @change.native.stop="handleCheckboxChange(threeItem)"></el-checkbox>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </div>
          </div>
        </template>
      </enfold-uc>
      <div class="node-content" v-loading="loading"></div>
    </enfold>
  </div>
</template>

<script>
import EnfoldUc from '@/components/basics/EnfoldUC'
import enfold from '@/components/basics/Enfold'
export default {
  name: "AccessLayout",
  data() {
    return {
      authorityList: [],
      roleId: '',
      flag: false,
      checkedIdList: [],
      checkedItemId: '',
      activeNames: [],
      saveIdList: [],
      loading: true
    }
  },
  created() {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const id = params.get('id');

    this.roleId = this.$route.params.id || id;
    this.roleId ? this.getAuthorityByRoleId() : this.$router.go(-1);
  },
  methods: {
    setIndeterminate(authorityList) {
      authorityList.isIndeterminate = false;
      authorityList.child.forEach((item) => {
        if (item.child) {
          this.setIndeterminate(item);
        }
      });
    },
    handleChange(value) {
      console.log(value);
    },
    getAuthorityByRoleId() {
      this.authorityList = [];
      this.checkedIdList = [];
      this.$http.post("/admin/access/getRightByRoleId", { id: this.roleId }, data => {
        this.authorityList = data.list;
        this.checkedIdList = data.clist;
        this.loading = false;
        this.setIndeterminate(this.authorityList[0]);
      });
    },
    setAuthorityByRoleId() {
      this.saveDataId(this.authorityList);
      let access = this.saveIdList.join(",");
      this.$http.post("/admin/access/setRightByRoleId", { role_id: this.roleId, access: access }, data => {
        console.log(data);
        this.$router.go(-1)
      });
    },
    saveDataId(items) {
      items.forEach((item) => {
        if (item.checked === 1) {
          this.saveIdList.push(item.id);
        }
        if (item.child.length > 0) {
          this.saveDataId(item.child);
        }
      });
    },
    handleCheckboxChange(items) {
      items.checked = items.checked ? 0 : 1;
      this.flag = items.checked;
      this.isChange(items);
    },
    isChange(items) {
      items.child.forEach((item) => {
        item.checked = this.flag;
        if (item.child.length > 0) {
          this.isChange(item);
        }
      });
    },
  },
  computed: {
    isCheckedAll() {
      return function (items) {
        items.checked = items.child.some((item) => {
          return item.checked === 1;
        })
          ? 1
          : 0;
        return items.checked;
      };
    },
    isIndeterminate() {
      return function (items) {
        let markOne = items.child.some((item) => {
          return item.checked === 1;
        })
          ? 1
          : 0;
        let markTwo = items.child.every((item) => {
          return item.checked === 1;
        })
          ? 1
          : 0;
        items.isIndeterminate = markOne && !markTwo;
        return items.isIndeterminate;
      };
    }
  },
  components: {
    enfold,
    EnfoldUc
  }
}
</script>

<style lang="scss" scoped>
.access-layout {
  width: 100%;
  height: 100%;

  .node-content-one {
    .el-checkbox--medium {
      padding: 9px 20px 7px 0px;
      border: #fff;
    }

    .node-content-two {
      padding-left: 22px;

      .node-content-three {
        border-top: 1px solid #ebeef5;

        .el-checkbox--small {
          padding: 7px 15px 5px 10px;
          border: 1px solid #dcdfe6;
        }

        .el-checkbox {
          display: inline-block;
          margin: 4px 4px 0px 0px;
        }
      }
    }
  }

  ::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #a7d0ff;
    border-radius: 2px;
  }

  .icon {
    width: 30px;
    height: 30px;
    padding-right: 6px;
  }
}
</style>